import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useSsrAdapter as k } from "../../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import { cssrAnchorMetaName as B, c as I } from "../../shared/cssr.js";
import { defineComponent as M, onMounted as T, nextTick as $, h as O, renderSlot as N } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as R } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const n = "v-hidden", j = I("[v-hidden]", {
  display: "none!important"
}), G = M({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateCount: Function,
    onUpdateOverflow: Function
  },
  setup(e, { slots: m }) {
    const v = R(null), p = R(null);
    function A(U) {
      const { value: s } = v, { getCounter: b, getTail: c } = e;
      let o;
      if (b !== void 0 ? o = b() : o = p.value, !s || !o)
        return;
      o.hasAttribute(n) && o.removeAttribute(n);
      const { children: C } = s;
      if (U.showAllItemsBeforeCalculate)
        for (const t of C)
          t.hasAttribute(n) && t.removeAttribute(n);
      const d = s.offsetWidth, W = [], i = m.tail ? c == null ? void 0 : c() : null;
      let f = i ? i.offsetWidth : 0, a = !1;
      const w = s.children.length - (m.tail ? 1 : 0);
      for (let t = 0; t < w - 1; ++t) {
        if (t < 0)
          continue;
        const l = C[t];
        if (a) {
          l.hasAttribute(n) || l.setAttribute(n, "");
          continue;
        } else
          l.hasAttribute(n) && l.removeAttribute(n);
        const y = l.offsetWidth;
        if (f += y, W[t] = y, f > d) {
          const { updateCounter: x } = e;
          for (let r = t; r >= 0; --r) {
            const h = w - 1 - r;
            x !== void 0 ? x(h) : o.textContent = `${h}`;
            const g = o.offsetWidth;
            if (f -= W[r], f + g <= d || r === 0) {
              a = !0, t = r - 1, i && (t === -1 ? (i.style.maxWidth = `${d - g}px`, i.style.boxSizing = "border-box") : i.style.maxWidth = "");
              const { onUpdateCount: F } = e;
              F && F(h);
              break;
            }
          }
        }
      }
      const { onUpdateOverflow: u } = e;
      a ? u !== void 0 && u(!0) : (u !== void 0 && u(!1), o.setAttribute(n, ""));
    }
    const S = k();
    return j.mount({
      id: "vueuc/overflow",
      head: !0,
      anchorMetaName: B,
      ssr: S
    }), T(() => A({
      showAllItemsBeforeCalculate: !1
    })), {
      selfRef: v,
      counterRef: p,
      sync: A
    };
  },
  render() {
    const { $slots: e } = this;
    return $(() => this.sync({
      showAllItemsBeforeCalculate: !1
    })), O("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      N(e, "default"),
      // $slots.counter should only has 1 element
      e.counter ? e.counter() : O("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      // $slots.tail should only has 1 element
      e.tail ? e.tail() : null
    ]);
  }
});
export {
  G as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/overflow/src/index.js
// module id = 1785
// module chunks = 67